import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import classes from "./EventsBody.module.scss";
import { useEffect, useState } from "react";
import axios from "../../../requests/axios.js";
import routes from "../../../requests/routes.js";
import { FaLocationDot } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { Image } from "antd";
import OptimizedImage from "../../../components/OptimizedImage.jsx";
import { trackEvent } from "../../../utils/analytics.js";

export const EventsBody = () => {
  const [events, setEvents] = useState(null);
  const [loading, setLoading] = useState(true);
  async function getEvents() {
    try {
      const response = await axios.get(routes.getAllEvents);
      setEvents(response.data.events);

      setLoading(false);
    } catch (err) {}
  }
  useEffect(() => {
    getEvents();
  }, []);

  function formatRange(startIso, endIso) {
    try {
      const start = new Date(startIso);
      const end = endIso ? new Date(endIso) : null;
      const date = start.toLocaleDateString(undefined, {
        weekday: "long",
        year: "numeric",
        month: "short",
        day: "numeric",
      });
      const startTime = start.toLocaleTimeString(undefined, {
        hour: "2-digit",
        minute: "2-digit",
      });
      const endTime = end
        ? end.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
          })
        : null;
      return endTime
        ? `${date} · ${startTime}–${endTime}`
        : `${date} · ${startTime}`;
    } catch {
      return startIso;
    }
  }

  return (
    !loading && (
      <>
        <header className={`${classes.header}`} aria-labelledby="events-title">
          <h2 id="events-title" className={`${classes.header__title}`}>
            Events
          </h2>
          <p className={`${classes.header__subtitle}`}>
            Explore our upcoming gatherings, workshops, and adventure
            days—presented like blog posts for easy browsing.
          </p>
        </header>
        <section className={`${classes.list}`} aria-label="Upcoming events">
          {events.map((e) => (
            <article
              key={e.id}
              className={`${classes.event}`}
              itemScope
              itemType="https://schema.org/Event"
            >
              <Link to={`/events/${e._id}`}>
                <span
                  className={`${classes.availability} ${
                    !e.isAvailable && classes.unavailable
                  }`}
                >
                  {`${e.isAvailable ? "Seats Available" : "Fully Booked"}`}
                </span>

                {e.bannerImage && (
                  <figure className={`${classes.media}`}>
                    <OptimizedImage
                      alt={`${e.name} hero`}
                      className={`${classes.mediaImg}`}
                      sources={[
                        {
                          type: "image/jpeg",
                          srcSet: e.bannerImage,
                        },
                      ]}
                      fallback={{
                        src: "../../assets/imgs/notFound/fallback-image.png",
                      }}
                    />
                  </figure>
                )}

                <div className={`${classes.body}`}>
                  <div className={`${classes.meta}`}>
                    <time
                      className={`${classes.when}`}
                      dateTime={e.datetime}
                      itemProp="startDate"
                    >
                      {formatRange(e.startDate, e.endDate)}
                    </time>
                    <span className={`${classes.dot}`} aria-hidden>
                      •
                    </span>
                  </div>

                  <h2 className={`${classes.name}`} itemProp="name">
                    {e.title}
                  </h2>

                  <span className={`${classes.where}`} itemProp="location">
                    <FaLocationDot /> {e.location}
                  </span>

                  <div className={`${classes.actions}`}>
                    {/* <a
                      className={`${classes.btn} ${classes.primary}`}
                      href={e.registerUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                      itemProp="url"
                    >
                      Book a seat
                    </a> */}
                    <a
                      className={`${classes.btn} ${classes.secondary}`}
                      href={e.registerUrl}
                      target="_blank"
                      rel="noreferrer noopener"
                      itemProp="url"
                      onClick={(event) => {
                        event.stopPropagation();
                        trackEvent({
                          event: "event_info_click",
                          facebookEvent: "Lead",
                          payload: {
                            content_name: e.title,
                            content_id: e._id,
                            content_category: "Events",
                            destination_url: e.registerUrl,
                          },
                        });
                      }}
                    >
                      More information
                    </a>
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </section>
      </>
    )
  );
};

export default EventsBody;
